<h1 mat-dialog-title>Hi TEST</h1>
<div mat-dialog-content>
    <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- This is the tree node template for leaf nodes -->
        <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="example-tree-node">
          <!-- use a disabled button to provide padding for tree leaf -->
          <button mat-icon-button disabled></button>
          {{node.name}}
        </cdk-nested-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: hasChild" class="example-tree-node">
          <button mat-icon-button [attr.aria-label]="'Toggle ' + node.name" cdkTreeNodeToggle>
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <span style="margin-left: 15px">{{node.name}}</span>
          <div [class.example-tree-invisible]="!treeControl.isExpanded(node)">
            <ng-container cdkTreeNodeOutlet></ng-container>
          </div>
        </cdk-nested-tree-node>
    </cdk-tree>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">No Thanks</button>
  <button mat-button>Ok</button>
</div>
